import { BallActionBase, HandoffActionBase, PlayerActionBase, PossessionActionBase } from "../generic-action";

/** ======== Action Line Types ======== */
export enum HockeyActionLineType {
  SKATE = "SKATE",
  SKATE_BACKWARDS = "SKATE_BACKWARDS",
  SKATE_LATERAL = "SKATE_LATERAL",
  PASS = "PASS",
  HANDOFF = "HANDOFF",
  SKATE_RECEIVING_HANDOFF = "SKATE_RECEIVING_HANDOFF",
  SKATE_BACKWARDS_RECEIVING_HANDOFF = "SKATE_BACKWARDS_RECEIVING_HANDOFF",
  SKATE_LATERAL_RECEIVING_HANDOFF = "SKATE_LATERAL_RECEIVING_HANDOFF",
  SHOOT = "SHOOT",
  SKATE_WITH_PUCK = "SKATE_WITH_PUCK",
  SKATE_BACKWARDS_WITH_PUCK = "SKATE_BACKWARDS_WITH_PUCK",
}
export type HockeyPlayerActionLineType =
  | HockeyActionLineType.SKATE
  | HockeyActionLineType.SKATE_BACKWARDS
  | HockeyActionLineType.SKATE_LATERAL;
export type HockeyBallActionLineType = HockeyActionLineType.PASS | HockeyActionLineType.SHOOT;
export type HockeyHandoffActionLineType = HockeyActionLineType.HANDOFF;
export type HockeyPlayerActionReceivingHandoffLineType =
  | HockeyActionLineType.SKATE_RECEIVING_HANDOFF
  | HockeyActionLineType.SKATE_BACKWARDS_RECEIVING_HANDOFF
  | HockeyActionLineType.SKATE_LATERAL_RECEIVING_HANDOFF;
export type HockeyPossessionActionLineType =
  | HockeyActionLineType.SKATE_WITH_PUCK
  | HockeyActionLineType.SKATE_BACKWARDS_WITH_PUCK
  | HockeyPlayerActionReceivingHandoffLineType;

/** ======== Actions ======== */
export type HockeySkateAction = PlayerActionBase<HockeyActionLineType.SKATE>;
export type HockeySkateBackwardsAction = PlayerActionBase<HockeyActionLineType.SKATE_BACKWARDS>;
export type HockeySkateLateralAction = PlayerActionBase<HockeyActionLineType.SKATE_LATERAL>;

export type HockeyPassAction = BallActionBase<HockeyActionLineType.PASS>;
export type HockeyShootAction = BallActionBase<HockeyActionLineType.SHOOT>;

export type HockeyHandoffAction = HandoffActionBase<HockeyActionLineType.HANDOFF>;

export type HockeySkateReceivingHandoffAction = PossessionActionBase<HockeyActionLineType.SKATE_RECEIVING_HANDOFF>;
export type HockeySkateBackwardReceivingHandoffAction =
  PossessionActionBase<HockeyActionLineType.SKATE_BACKWARDS_RECEIVING_HANDOFF>;
export type HockeySkateLateralReceivingHandoffAction =
  PossessionActionBase<HockeyActionLineType.SKATE_LATERAL_RECEIVING_HANDOFF>;

export type HockeySkateWithPuckAction = PossessionActionBase<HockeyActionLineType.SKATE_WITH_PUCK>;
export type HockeySkateBackwardsWithPuckAction = PossessionActionBase<HockeyActionLineType.SKATE_BACKWARDS_WITH_PUCK>;

/** ======== Action Groups ======== */
export type HockeyPlayerAction = HockeySkateAction | HockeySkateBackwardsAction | HockeySkateLateralAction;
export type HockeyBallAction = HockeyPassAction | HockeyShootAction;
// export type HockeyHandoffAction = HockeyHandoffAction;
export type HockeyNonHandoffPossessionAction = HockeySkateWithPuckAction | HockeySkateBackwardsWithPuckAction;
export type HockeyPlayerActionReceivingHandoff =
  | HockeySkateReceivingHandoffAction
  | HockeySkateBackwardReceivingHandoffAction
  | HockeySkateLateralReceivingHandoffAction;
